var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoxSmall = function SvgBoxSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#555F6D",
    fillRule: "evenodd",
    d: "M6.76.758a.53.53 0 0 1 .48 0l5.775 2.975c.175.09.285.27.285.467v5.6c0 .197-.11.377-.285.467L7.24 13.242a.53.53 0 0 1-.48 0L.985 10.267A.53.53 0 0 1 .7 9.8V4.2c0-.196.11-.376.285-.467zm-5.01 4.28V9.48l4.725 2.434V7.33zM7.525 7.33v4.585L12.25 9.48V5.038zM11.6 4.186l-1.754.85-4.618-2.308L7 1.816zm-7.528-.862-1.674.862 4.6 2.23 1.656-.802z",
    clipRule: "evenodd"
  })));
};
export default SvgBoxSmall;